import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const ToggleCommunicationCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`
